import React, { useEffect, useState } from "react";
import { Typography, InputLabel, TextField, Autocomplete } from "@mui/material";
import { FormControlStyles } from "@Components/DropDown/DropDownStyles";

const MultiSelectionDropDown = ({
  state,
  setState,
  name,
  defaultFirst,
  classname,
  setIsEmpty,
  isEmpty,
  label,
  items,
  disabled,
  placeholder,
  size,
  dropDownError,
  helperText,
  extraProps,
}) => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (defaultFirst && items.length > 0 && !state) {
      setState(items[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  function handleOnChange(event, newValue) {
    if (newValue) {
      setState(newValue.id);
      setInputValue(""); // clear search text
      if (isEmpty) setIsEmpty(false);
    }
  }

  return (
    <FormControlStyles
      size={size}
      variant="outlined"
      className={classname}
      fullWidth
      error={dropDownError}
    >
      {label && <InputLabel shrink>{label}</InputLabel>}

      <Autocomplete
        value={items.find((item) => item.id === state) || null}
        onChange={handleOnChange}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        options={items}
        disabled={disabled}
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            error={dropDownError}
            {...extraProps}
          />
        )}
      />

      {isEmpty && (
        <Typography variant="body2" color="error" marginTop={1}>
          {name} is required
        </Typography>
      )}
      {helperText && (
        <Typography variant="body2" color="error" marginTop={1}>
          {helperText}
        </Typography>
      )}
    </FormControlStyles>
  );
};

export default MultiSelectionDropDown;
